import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import Form from 'components/Form';
import FooterPanel from './FooterPanel';
import HeaderPanel from './HeaderPanel';
import inputs from './form.json';
import { resetPassword } from 'redux/actions';

const ForgotPasswordPanel = ({ changeEv }) => {
    const dispatch = useDispatch();
    const handleSaveUserData = (data) => {
        dispatch(resetPassword(data.email));
        changeEv('sentForgotPassword');
    };
    return (
        <Form
            className="form-outline sign--form"
            type="forgotPassword"
            inputs={inputs.forgotPassword}
            data={[]}
            title="Zaloguj się"
            handleSubmitEv={handleSaveUserData}
            submitTitle="Wyślij"
            formContent="<p>Nie ma problemu, każdemu może się zdarzyć!  Po prostu podaj nam swój adres e-mail, a wyślemy Ci link do zmiany hasła.</p>"
            formHeader={<HeaderPanel>Przypomnienie hasła</HeaderPanel>}
            formFooter={<FooterPanel changeEv={() => changeEv('login')}>Powrót do logowania</FooterPanel>}
        />
    );
};

ForgotPasswordPanel.propTypes = {
    changeEv: PropTypes.func.isRequired,
};

export default ForgotPasswordPanel;
